// extracted by mini-css-extract-plugin
module.exports = {"list":"_10zvGnpQZuUUBuHf7-8iUC"};